exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--file__vwH0v{cursor:pointer}.styles--icon__p7Shw{background:#79a5d2;height:21px;border-radius:4px}.styles--filename__3fFWm{display:block;margin-top:5px}.styles--filename__3fFWm audio{width:100%}\n", ""]);

// exports
exports.locals = {
	"file": "styles--file__vwH0v",
	"icon": "styles--icon__p7Shw",
	"filename": "styles--filename__3fFWm"
};